import * as types from '../constants/settingConstants';

export const createLicense = (licenseData) => ({
  type: types.CREATE_LICENSE_REQUEST,
  payload: licenseData
});

export const getLicenses = (params) => ({
  type: types.GET_LICENSES_REQUEST,
  payload: params
});

export const deleteLicense = (licenseId) => ({
  type: types.DELETE_LICENSE_REQUEST,
  payload: licenseId
});

export const updateLicense = (licenseData) => ({
  type: types.UPDATE_LICENSE_REQUEST,
  payload: licenseData
});

export const changeLicenseStatus = (statusData) => ({
  type: types.CHANGE_LICENSE_STATUS_REQUEST,
  payload: statusData
});

export const getLicenseUsage = (params) => ({
  type: types.GET_LICENSE_USAGE_REQUEST,
  payload: params
});